
<app-header></app-header>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
<ngx-spinner></ngx-spinner>
<div class="row pb-2 mt-4 ml-1 mr-1">
    <div class="col">
      <h4>
        <div>{{ CreateShowHide ? 'Add Compatible Item' : UpdateShowHide ? 'Edit Compatible Item': 'Compatible Items'}} </div>
      </h4>
    </div>
</div>
<div class="row mb-2 ml-1 mr-1">
  <div class="col" *ngIf="!(CreateShowHide || UpdateShowHide)">
    <label for="txtNomenclature">Choose a Nomenclature </label><span style="color:red;">&nbsp;* </span>
    <select (change)="GetCompatibleItems()" [(ngModel)]="selectedNomenclature" id="txtSelectedNomenclature">
      <option [ngValue]="uniquenomenclature" *ngFor="let uniquenomenclature of uniqueNomenclatures">
        {{uniquenomenclature}} </option>
    </select>
  </div>
  <div class="col">
    <button type="button" *ngIf="AddShowHide" class="btn btn-success float-right" aria-controls="AddCompatibleItem" (click)="AddCompatibleItem()">
      <i class="fas fa-plus-circle"></i> Add Compatible Item</button>
  </div>
</div>
<form [formGroup]="frmCompatibleItem" *ngIf="CreateShowHide || UpdateShowHide" >
  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">
        
        <div class="form-group col-lg-2" *ngIf="CreateShowHide === false">
          <label for="txtNomenclature">Nomenclature</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtNomenclature" formControlName="Nomenclature" required readonly="readonly">
        </div>
        <div class="form-group col-lg-2" *ngIf="CreateShowHide === true">
          <label for="txtNomenclature">Nomenclature</label><span style="color:red;">&nbsp;*</span>
          <select class="form-control" formControlName="Nomenclature" id="txtSelectedNomenclature">
            <!--<option *ngFor="let uniquenomenclature of uniqueNomenclatures">{{uniquenomenclature}} </option>-->
            <option [ngValue]="product.nomenclature" *ngFor="let product of products">{{product.nomenclature}} </option>
          </select>
        </div>

        <div class="form-group col-lg-2">
          <label for="txtCompatibleItem">Compatible Item</label><span style="color:red;">&nbsp;*</span>
            <select class="form-control" formControlName="CompatibleItem" id="txtCompatibleItem">
              <option [ngValue]="product.nomenclature" *ngFor="let product of products">{{product.nomenclature}} </option>
            </select>
        </div>
      </div>
    </div>
  </div>

  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">
        <div class="form-group col-lg-8">
          <button type="button" class="btn btn-success" (click)="fileInput.click()" >Choose File</button><span style="color:red;"> *</span>
          <input  hidden #fileInput type="file" accept=".jpg" id="file" formControlName="CompatibleImage" (change)="setFilename(fileInput.files)" />
          <label >{{ this.filename }}</label>
          <img *ngIf="isShown" src="{{baseUrl + this.compatibleitemname}}" style="max-width:20%; height: auto;" alt="{{this.compatibleitemname}}" title="{{this.compatibleitemname}}">
        </div>
        <div *ngIf="frmCompatibleItem.get('CompatibleImage').invalid && frmCompatibleItem.get('CompatibleImage').touched"  class="validation">
          <small *ngIf="frmCompatibleItem.get('CompatibleImage').errors.required">
            Must be required!!!
          </small>
          
        </div>
      </div>
    </div>
  </div>
  
  <div class="row ml-1 mr-1">
      <div class="col">
        <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreateCompatibleItem(fileInput.files)">
          <i class="fas fa-pen" area-hidden="true"></i> <span class="d-none d-md-inline d-lg-inline">Submit</span>
        </button>
        <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" (click)="UpdateCompatibleItem(fileInput.files)">
          <i class="fas fa-pen" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Update</span>
        </button>  
        <a>
          <button type="button" aria-controls="addCompatibleItem" *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary">
            <i class="fas fa-undo" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Cancel</span>
          </button>
        </a>
      </div>
  </div>
</form>

<!-- <main role="main" class="flex-shrink-0">
    <div class="container-fluid mt-5 mb-4"> -->
<!-- <div class="container" style="float:left;"> -->

  <!-- <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
  <div class="row pb-2">
    <div class="col">
      <h4>Compatible Items</h4>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col">
      <label for="txtNomenclature">Choose a Nomenclature </label><span style="color:red;">&nbsp;* </span>
      <select (change)="GetCompatibleItems()" [(ngModel)]="selectedNomenclature" id="txtSelectedNomenclature">
        <option [ngValue]="uniquenomenclature" *ngFor="let uniquenomenclature of uniqueNomenclatures">
          {{uniquenomenclature}} </option>
      </select>
    </div>
    <div class="col">
      <button type="button" *ngIf="AddShowHide" class="btn btn-success float-right" data-toggle="modal"
        data-target="#addCompatibleItem" aria-controls="AddCompatibleItem" (click)="AddCompatibleItem()">
        <i class="fas fa-plus-circle"></i> Add Compatible Item</button>

    </div>
  </div>
  <div class="modal fade" id="addCompatibleItem" tabindex="-1" #addCompatibleItem
    aria-labelledby="addCompatibleItemTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role=document>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addCompatibleItemTitle">Enter Compatible Item Information</h5>
          <button type="button" class="close" data-dismiss="modal" (click)="Cancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="frmCompatibleItem">
            <div class="form-row">
              <div class="form-group col-lg-4" *ngIf="CreateShowHide === false ">

                <label for="txtNomenclature">Nomenclature</label><span style="color:red;">&nbsp;*</span>
                <input type="text" class="form-control" id="txtNomenclature" formControlName="Nomenclature" required
                  readonly="readonly">





              </div>
              <div class="col-md-4 mb-2" *ngIf="CreateShowHide === true ">

                <label for="txtNomenclature">Nomenclature</label><span style="color:red;">&nbsp;*</span>
                <select formControlName="Nomenclature" id="txtSelectedNomenclature">
                  <option *ngFor="let uniquenomenclature of uniqueNomenclatures">{{uniquenomenclature}} </option>
                </select>





              </div>
              <div class="col-md-4 mb-2">
                <label for="txtCompatibleItem">Compatible Item</label><span style="color:red;">&nbsp;*</span>
                <select class="form-control" formControlName="CompatibleItem" id="txtCompatibleItem">
                  <option [ngValue]="product.nomenclature" *ngFor="let product of products">{{product.nomenclature}}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <div class="row">
                <div class="col-md-6">
                  <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreateCompatibleItem()">
                    Add</button>
                  <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" data-toggle="modal"
                    data-dismiss="modal" (click)="UpdateCompatibleItem()">Update</button>
                </div>
                <div class="col-md-6">
                  <button type="button" data-target="#addCompatibleItem" data-toggle="modal"
                    aria-controls="addCompatibleItem" *ngIf="CancelShowHide" (click)="Cancel()"
                    class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div> -->
  
 <!----> 
  <div class="row ml-1 mr-1" *ngIf="!(CreateShowHide || UpdateShowHide)">
    <div class="col">
      <div class="table">
        <table id="compatibleitems" class="table table-striped table-bordered table-hover table-sm">
          <thead class="thead-dark">
            <tr>
              <th scope="col" *ngIf="EditShowHide">Actions</th>
              <th scope="col">Nomenclature</th>
              <th scope="col"> Compatible Item</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items | paginate: config ">
              <td *ngIf="EditShowHide">
                <table>
                  <tr>
                    <td>
                      <button type="button" data-target="#addCompatibleItem" data-toggle="modal" class="btn btn-info btn-sm"
                              (click)="EditCompatibleItem(item)" title="Edit">
                        <i class="fas fa-pen"></i> <span class="d-none d-md-inline d-lg-inline">Edit</span>
                      </button>
                    </td>
                    <td>
                      <button class="btn btn-info btn-sm" (click)="DeleteCompatibleItem(item.Id)" title="Delete">
                        <i class="far fa-trash-alt fa-lg text-danger"></i>
                        <span class="d-none d-md-inline d-lg-inline">Delete</span>
                      </button>
                    </td>
                  </tr>
                </table>
               
              </td>
              <td>{{item.Nomenclature}}</td>
              <td>{{item.CompatibleItem1}}</td>
            </tr>
            <tr>
              <td colspan="7" style="text-align: right;">
                <pagination-controls (pageChange)="pageChanged($event)" id="CompatibleItem"></pagination-controls>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
<!-- </div> -->
<!-- </div>
</main> -->
